import { render } from "./page-sav-gestion.vue?vue&type=template&id=2d5cef49"
import script from "./page-sav-gestion.vue?vue&type=script&lang=js"
export * from "./page-sav-gestion.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/Web apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__